const MuiTableCell = (palette) => ({
  head: {
    backgroundColor: palette.primary.main,
    color: palette.common.white,
  },
  body: {
    fontSize: 14,
  },
});

export default MuiTableCell;
